import { render, staticRenderFns } from "./chat-widget.vue?vue&type=template&id=aab1bf4a"
import script from "./chat-widget.vue?vue&type=script&lang=ts"
export * from "./chat-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports